import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import messageSubscriberService from '../../services/messageSubscriber';

const initialState = {
  loading: false,
  subscribers: [],
  error: '',
  params: {
    page: 1,
    perPage: 15,
  },
  pagination: {},
};

export const fetchMessageSubscriber = createAsyncThunk(
  'messageSubscriber/fetchMessageSubscriber',
  (params = {}) => {
    return messageSubscriberService
      .getAll({ ...initialState.params, ...params })
      .then((res) => res);
  }
);

const messageSubscriberSlice = createSlice({
  name: 'messageSubscriber',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchMessageSubscriber.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchMessageSubscriber.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.subscribers = payload?.data ?? [];
      state.pagination = payload?.pagination ?? {};
      if (payload?.pagination) {
        state.params.page = payload.pagination.page;
        state.params.perPage = payload.pagination.perPage;
      }
      state.error = '';
    });
    builder.addCase(fetchMessageSubscriber.rejected, (state, action) => {
      state.loading = false;
      state.subscribers = [];
      state.error = action.error.message;
    });
  },
});

export default messageSubscriberSlice.reducer;
